import PropTypes from "prop-types";
import styles from "./RejectedKycDetail.module.css";
import Lottie from "lottie-react";
import approved from "./Animation-RejectedGIF.json";
import { useNavigate, useParams } from "react-router-dom";

const RejectedKycDetail = ({ className = "" }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  console.log("InKYCStustatus", id);

  return (
    <div className={`${styles.pageContainer} d-flex justify-content-center align-items-center`}>
      <div className={styles.httpslottiefilescomanimatParent}>
        <Lottie className={styles.httpslottiefilescomanimatIcon} animationData={approved} loop={true} />
        <div className={styles.successfullyGeneratedRequest}>Rejected KYC Detail</div>
        <button
          className={styles.returnToKycList}
          onClick={() => {
            navigate(`/content/company/kyclist/main`);
          }}
        >
          <b className={styles.returnToKyc}>Return to KYC List</b>
        </button>
      </div>
    </div>
  );
};

RejectedKycDetail.propTypes = {
  className: PropTypes.string,
};

export default RejectedKycDetail;

// ApprovedPOPup
